import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../../../theme';
import { getOrder, getTravellers, getEveryPortServicesToRefund } from '../../../../../Checkout/store/order/selectors';
import NasRefundServices from '../../../../../NasRefundServices/NasRefundServices';
const AirportServices = props => {
    const theme = useTheme('Exchange').AirportServices;
    const order = useSelector(getOrder);
    const travellersToRefund = useSelector(getTravellers);
    const nasServicesToRefund = useSelector(getEveryPortServicesToRefund);
    const onSuccessfulRefund = () => {
        props.reloadOrder();
    };
    return (React.createElement("div", { className: theme.wrapper },
        React.createElement(NasRefundServices, { services: nasServicesToRefund.map(selected => selected.product), selectedServices: nasServicesToRefund, onSuccessfullyRefunded: onSuccessfulRefund, onCancel: props.onCancel, order: order, travellersToRefund: travellersToRefund.map(traveller => traveller.id) })));
};
export default AirportServices;
